<template>
  <div class="footer-container">
    <div class="content-box">
      <div class="logo-row flex">
        <div class="left-logo"></div>
        <div class="right-local">重庆市两江新区黄山大道中段5号水星大厦B座16层</div>
        <div class="right-phone">400-636-0093</div>
      </div>
      <div class="prod-row flex">
        <div class="prod-item" v-for="(item, index) in prods" @click="clickOtherProd(item.url)" :key="index">
          <img :src="require(`../assets/footer/${item.icon}.png`)" alt="" />
        </div>
      </div>
      <div class="info-row">
        <div class="row">
          科技部西南信息中心·重庆尚唯信息技术有限公司&nbsp;|&nbsp;增值电信业务经营许可证:
          <a href="http://www.sunwayinfo.com.cn/soft/icp.pdf" target="_blank">渝B2-20220077 </a>
        </div>
        <div class="row">
          <a v-if="siteType !== 'image'" href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
            target="_blank">渝ICP备17012494号-1
            <span v-if="currentPath !== '/login'">&nbsp;|&nbsp;</span>
          </a>
          <span v-if="currentPath !== '/login'">您的IP地址:{{ IP }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'FooterCom',
  data() {
    return {
      prods: [
        {
          icon: 'gpd',
          url: 'http://gpd.sunwayinfo.com.cn/',
        },
        {
          icon: 'jybz',
          url: 'https://gwbz.sunwayinfo.com.cn/',
        },
        {
          icon: 'tech',
          url: 'http://bg.sunwayinfo.com.cn/',
        },
      ],
      siteType: '',
    }
  },
  computed: {
    ...mapState(['IP']),
    currentPath() {
      return this.$route.path
    }
  },
  mounted() {
    this.siteType = window.config.siteType
  },
  methods: {
    clickOtherProd(url) {
      window.open(url, '_blank')
    }
  }
}
</script>
<style lang="less" scoped>
.footer-container {
  box-sizing: border-box;
  height: 484px;
  min-width: 1600px;
  background-image: url(../assets/footer/bg.jpg);
  background-size: cover;
}

.content-box {
  margin: 0 auto;
  width: 1600px;
  padding: 0 12px;
}

.logo-row {
  padding-top: 40px;
  align-items: center;
  font-size: 15px;
  color: #68718b;
  line-height: 24px;
}

.left-logo {
  width: 480px;
  height: 114px;
  background-image: url(../assets/footer/footer-logo.png);
  background-size: contain;
}

.right-local {
  margin-left: auto;

  &::before {
    content: '';
    width: 46px;
    height: 46px;
    background-size: contain;
    margin-right: 14px;
    display: inline-block;
    vertical-align: middle;
    margin-top: -3px;
    background-image: url(../assets/icons/local.png);
  }
}

.right-phone {
  margin-left: 48px;

  &::before {
    content: '';
    width: 46px;
    height: 46px;
    margin-right: 14px;
    background-size: contain;
    display: inline-block;
    vertical-align: middle;
    margin-top: -3px;
    background-image: url(../assets/icons/phone.png);
  }
}

.prod-row {
  margin-top: 80px;
  justify-content: center;
}

.prod-item {
  cursor: pointer;

  img {
    height: 45px;
  }

  &:not(:last-child) {
    margin-right: 60px;
  }
}

.info-row {
  margin: 100px auto 0;
  padding-top: 24px;
  width: 1104px;
  text-align: center;
  border-top: 1px solid #98a0b5;
  font-size: 15px;
  color: #98a0b5;
  line-height: 21px;

  a {
    color: #98a0b5;
  }
}
</style>
